import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminApi, formatApiErrorDetail } from '../../lib/adminApi';
import { ADMIN_ADD_CLIENT } from '../../constants/testIds';

const PACKAGES = [
  { id: 'solo', label: 'Ambanji Solo — $79/mo' },
  { id: 'growth', label: 'Ambanji Growth — $249/mo' },
  { id: 'agency', label: 'Ambanji Agency — $549/mo' },
  { id: 'scale', label: 'Ambanji Scale — $1,099/mo' },
];

const inputClass = 'w-full px-3.5 py-2.5 rounded-lg bg-white border border-stone-300 text-sm focus:outline-none focus:ring-2 focus:ring-[#F97316]';

const AdminAddClient = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    business_name: '',
    contact_email: '',
    contact_phone: '',
    package_id: 'solo',
    gbp_location: '',
    notes: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const update = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await adminApi.post('/admin/clients', form);
      navigate('/admin/clients');
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid={ADMIN_ADD_CLIENT.page} className="max-w-xl">
      <h1 className="text-2xl font-extrabold text-stone-900 mb-1">Add client</h1>
      <p className="text-stone-500 text-sm mb-7">Manually onboard a client before CRM automation is live.</p>

      <form onSubmit={handleSubmit} className="bg-white rounded-2xl border border-stone-200 p-6 space-y-4">
        <div>
          <label className="block text-xs font-semibold text-stone-500 mb-1.5">Business name</label>
          <input data-testid={ADMIN_ADD_CLIENT.businessNameInput} required value={form.business_name} onChange={update('business_name')} className={inputClass} placeholder="Joe's Pizza" />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-semibold text-stone-500 mb-1.5">Contact email</label>
            <input data-testid={ADMIN_ADD_CLIENT.contactEmailInput} type="email" required value={form.contact_email} onChange={update('contact_email')} className={inputClass} placeholder="joe@pizza.com" />
          </div>
          <div>
            <label className="block text-xs font-semibold text-stone-500 mb-1.5">Contact phone</label>
            <input data-testid={ADMIN_ADD_CLIENT.contactPhoneInput} value={form.contact_phone} onChange={update('contact_phone')} className={inputClass} placeholder="(555) 555-5555" />
          </div>
        </div>
        <div>
          <label className="block text-xs font-semibold text-stone-500 mb-1.5">Package</label>
          <select data-testid={ADMIN_ADD_CLIENT.packageSelect} value={form.package_id} onChange={update('package_id')} className={inputClass}>
            {PACKAGES.map((p) => (
              <option key={p.id} value={p.id}>{p.label}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-xs font-semibold text-stone-500 mb-1.5">Google Business Profile location</label>
          <input data-testid={ADMIN_ADD_CLIENT.gbpLocationInput} value={form.gbp_location} onChange={update('gbp_location')} className={inputClass} placeholder="123 Main St, Austin TX" />
        </div>
        <div>
          <label className="block text-xs font-semibold text-stone-500 mb-1.5">Notes</label>
          <textarea data-testid={ADMIN_ADD_CLIENT.notesInput} value={form.notes} onChange={update('notes')} className={inputClass} rows={3} placeholder="Anything worth remembering about this client…" />
        </div>

        {error && <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{error}</p>}

        <div className="flex gap-3 pt-2">
          <button data-testid={ADMIN_ADD_CLIENT.submitButton} type="submit" disabled={loading} className="px-5 py-2.5 rounded-lg bg-[#F97316] text-white text-sm font-bold hover:bg-[#EA580C] transition disabled:opacity-60">
            {loading ? 'Saving…' : 'Add client'}
          </button>
          <button data-testid={ADMIN_ADD_CLIENT.cancelButton} type="button" onClick={() => navigate('/admin/clients')} className="px-5 py-2.5 rounded-lg border border-stone-300 text-sm font-semibold text-stone-700 hover:bg-stone-50 transition">
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default AdminAddClient;
